import * as React from "react";
import {
  Edit,
  Title,
  ReferenceArrayInput,
  AutocompleteArrayInput,
} from "react-admin";
import { SimpleForm } from "../common/SimpleForm";
import { RESTAURANT_TYPES } from "../enums/RestaurantTypes";
import { validateRequired } from "../utils/Validations";

const RestaurantMercadoPagoTokenTitle = () => <Title title={"Mercado Pago"} />;

const RestaurantMercadoPagoTokenEdit = () => (
  <Edit
    title={<RestaurantMercadoPagoTokenTitle />}
    mutationMode="pessimistic"
    redirect="list"
  >
    <SimpleForm>
      <ReferenceArrayInput
        source="restaurants"
        reference="restaurants"
        perPage={100}
        filter={{
          activeOrOnboarding: true,
          type: RESTAURANT_TYPES.REGULAR,
        }}
      >
        <AutocompleteArrayInput
          filterToQuery={(searchText) => ({ name: searchText })}
          label="Restaurantes Asociados"
          helperText="Puedes elegir más de un restaurante"
          fullWidth
          optionText="name"
          validate={validateRequired}
        />
      </ReferenceArrayInput>
    </SimpleForm>
  </Edit>
);

export default RestaurantMercadoPagoTokenEdit;
